import type { Address } from "~~/models/Session"
import { getExpUserProfile } from "./ExpApi/expUser"

export enum AddressType {
	INVOICE,
	SHIPPING,
	NORMAL
}

export function changeAddress(address: Address, type: AddressType) {
	return useFetch('/api/neo/frontend/_api/user/changeAddress', {
		headers: {
			'bt-use-user-auth': 'true',
			'csrf-token': useCurrentUserState()?.value?.csrfToken
		},
		method: 'POST',
		body: {
			address: address,
			type: type
		}
	})
}

export function setDefaultInvoiceAddress(addressId: string) {
	return useFetch('/api/neo/frontend/_api/user/setDefaultInvoiceAddress', {
		headers: {
			'bt-use-user-auth': 'true',
			'csrf-token': useCurrentUserState()?.value?.csrfToken
		},
		method: 'POST',
		body: {
			addressId: addressId
		}
	})
}

export function setDefaultShippingAddress(addressId: string) {
	return useFetch('/api/neo/frontend/_api/user/setDefaultShippingAddress', {
		headers: {
			'bt-use-user-auth': 'true',
			'csrf-token': useCurrentUserState()?.value?.csrfToken
		},
		method: 'POST',
		body: {
			addressId: addressId
		}
	})
}

export function removeAddress(addressId: string) {
	return useFetch('/api/neo/frontend/_api/user/removeAddress', {
		headers: {
			'bt-use-user-auth': 'true',
			'csrf-token': useCurrentUserState()?.value?.csrfToken
		},
		method: 'POST',
		body: {
			addressId: addressId
		}
	})
}

export function changePassword(currentPassword: string, newPassword: string) {
	return useFetch('/api/neo/frontend/_api/user/changePassword', {
		headers: {
			'bt-use-user-auth': 'true',
			'csrf-token': useCurrentUserState()?.value?.csrfToken
		},
		method: 'POST',
		body: {
			currentPassword: currentPassword,
			newPassword: newPassword
		}
	})
}

export async function registerUserFromPayload(csrfToken: string, password: string) {
    return await useFetch('/api/neo/frontend/_api/user/registerUserFromPayload', {
        headers: {
            'bt-use-user-auth': 'true',
            'csrf-token': csrfToken
        },
        method: 'POST',
        body: {
            password: password
        }
    })
}

export async function neoLogin(username: string, password: string) {
    return login(username, password);
}

export async function login(email: string, password: string, captcha?: string) {
    const csrfToken = useCurrentUserState()?.value?.csrfToken;
    let body = {
        login: {
            email: email,
            password: password
        }
    }
    if (captcha) body.captcha = captcha
    let response;
    try {
        response = await $fetch('/api/neo/frontend/_api/user/login', {
            headers: {
                'bt-use-user-auth': 'true',
                'csrf-token': csrfToken
            },
            method: 'POST',
            body: body,
        });
    } catch (err) {
        console.error(err);
    }
    return response;
}

export function changeBasicUserData(firstname: string, lastname: string, email: string, birthday: number, gender: Gender) {
    return useFetch('/api/neo/frontend/_api/user/changeBasicUserData', {
        headers: {
            'bt-use-user-auth': 'true',
            'csrf-token': useCurrentUserState()?.value?.csrfToken
        },
        method: 'POST',
        body: {
            userData: {
				firstname: firstname,
				lastname: lastname,
				email: email,
				birthday: birthday,
				gender: gender
			}
        }
    });
}

export async function tokenLogin(token: string) {
	const { error, data } = await useFetch('/api/neo/frontend/_api/user/loginWithToken', {
		headers: {
			'bt-use-user-auth': 'true',
			'csrf-token': useCurrentUserState()?.value?.csrfToken,
		},
		method: 'POST',
		body: {
			token: token,
		},
	});
	
	if (error?.value) {
		return false;
	}
	
	await getExpUserProfile();
	return true;
}